module.exports = __webpack_public_path__ + "static/media/icon-email.5890f596.svg";